// extracted by css-extract-rspack-plugin
export default {"BannerContainer":"LicenseTokenMissingBanner-module__BannerContainer___qGJ6z","BannerBody":"LicenseTokenMissingBanner-module__BannerBody___E8nwY"};